/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Status_ConnectingInputs */

const th_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังเชื่อมต่อรีเลย์…`)
};

const en_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting to the relay…`)
};

const ja_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リレーに接続中…`)
};

const zh_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在连接中继…`)
};

const es_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando con el relay…`)
};

const pt_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando ao relay…`)
};

const id_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghubungkan ke relay…`)
};

const fr_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion au relais…`)
};

const tl_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kumokonekta sa relay…`)
};

const vi_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kết nối tới relay…`)
};

const ko_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`릴레이에 연결 중…`)
};

const de_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zum Relay…`)
};

const ru_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключаемся к ретранслятору…`)
};

const tr_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktarıcıya bağlanılıyor…`)
};

const it_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connessione al relay…`)
};

const pl_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączenie z przekaźnikiem…`)
};

const uk_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підключаємося до ретранслятора…`)
};

const hi_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिले से जोड़ा जा रहा है…`)
};

const ar_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الاتصال بالمُرحِّل…`)
};

const ms_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyambung ke geganti…`)
};

const bn_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিলেতে যুক্ত হচ্ছে…`)
};

const zh_tw2_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在連線到轉送伺服器…`)
};

const zh_hk2_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在連線到轉送伺服器…`)
};

const ur_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ریلے سے جڑ رہا ہے…`)
};

const fa_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال اتصال به بازپخش‌کننده…`)
};

const sw_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaunganisha na kipeperushi…`)
};

const nl_video_status_connecting = /** @type {(inputs: Video_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden met het relais…`)
};

/**
* | output |
* | --- |
* | "Connecting to the relay…" |
*
* @param {Video_Status_ConnectingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_status_connecting = /** @type {((inputs?: Video_Status_ConnectingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Status_ConnectingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_status_connecting(inputs)
	if (locale === "ja") return ja_video_status_connecting(inputs)
	if (locale === "zh") return zh_video_status_connecting(inputs)
	if (locale === "es") return es_video_status_connecting(inputs)
	if (locale === "pt") return pt_video_status_connecting(inputs)
	if (locale === "id") return id_video_status_connecting(inputs)
	if (locale === "fr") return fr_video_status_connecting(inputs)
	if (locale === "tl") return tl_video_status_connecting(inputs)
	if (locale === "vi") return vi_video_status_connecting(inputs)
	if (locale === "ko") return ko_video_status_connecting(inputs)
	if (locale === "de") return de_video_status_connecting(inputs)
	if (locale === "ru") return ru_video_status_connecting(inputs)
	if (locale === "tr") return tr_video_status_connecting(inputs)
	if (locale === "it") return it_video_status_connecting(inputs)
	if (locale === "pl") return pl_video_status_connecting(inputs)
	if (locale === "uk") return uk_video_status_connecting(inputs)
	if (locale === "hi") return hi_video_status_connecting(inputs)
	if (locale === "ar") return ar_video_status_connecting(inputs)
	if (locale === "ms") return ms_video_status_connecting(inputs)
	if (locale === "bn") return bn_video_status_connecting(inputs)
	if (locale === "zh-TW") return zh_tw2_video_status_connecting(inputs)
	if (locale === "zh-HK") return zh_hk2_video_status_connecting(inputs)
	if (locale === "ur") return ur_video_status_connecting(inputs)
	if (locale === "fa") return fa_video_status_connecting(inputs)
	if (locale === "sw") return sw_video_status_connecting(inputs)
	if (locale === "nl") return nl_video_status_connecting(inputs)
	return en_video_status_connecting(inputs)
});